function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { useStore, useStoreActions, useStoreStatic } from "../../store/store-context";
import { ErrorType, Step, isValidWorkspace } from "./VendorOnboardingModal.utils";
import { FirstStep } from "./FirstStep";
import { SecondStep } from "./SecondStep";
import styles from "./VendorOnboardingModal.module.scss";
import { CloseButton, ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext } from 'seagull';
import { useSwitchBusiness } from "../../hooks/useSwitchBusiness";
import { useEventReporter } from "../../event-reporter";
import { SavingStep } from "./SavingStep";
import { QBOStep } from "./QBOStep";
import { VobQboState } from "../../types/api.model";
import { selectors } from "../../store/state-selectors";
import { QBOSetupStep } from "./QBOSetupStep";
export default function VendorOnboardingModal(props) {
  const {
    dismissModal,
    vobQboState,
    showQboStep
  } = props;
  const {
    getState
  } = useStoreStatic();
  const workspaces = useStore(selectors.user.workspaces);
  const {
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const {
    switchBusiness
  } = useSwitchBusiness();
  const {
    reportToHeap,
    reportToHubspot,
    reportToAppcues
  } = useEventReporter();
  const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
  const [step, setStep] = useState(vobQboState === VobQboState.Started ? Step.QBO : vobQboState === VobQboState.ConnectionTriggered && isLinkedToQbo ? Step.QBOSetup : Step.First);
  const shouldShowCloseButton = step !== Step.QBO && step !== Step.QBOSetup && workspaces && workspaces.some(isValidWorkspace);
  const [vobData, setVobData] = useState(() => {
    var _userInfo$business, _userInfo$firstName, _userInfo$lastName, _userInfo$businessNam;
    const {
      userInfo
    } = getState();
    const postalAddress = userInfo === null || userInfo === void 0 || (_userInfo$business = userInfo.business()) === null || _userInfo$business === void 0 ? void 0 : _userInfo$business.postalAddress;
    return {
      name: {
        first: (_userInfo$firstName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName()) !== null && _userInfo$firstName !== void 0 ? _userInfo$firstName : '',
        last: (_userInfo$lastName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName()) !== null && _userInfo$lastName !== void 0 ? _userInfo$lastName : ''
      },
      companyName: (_userInfo$businessNam = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessName()) !== null && _userInfo$businessNam !== void 0 ? _userInfo$businessNam : '',
      postalAddress: {
        address1: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressOne) || '',
        address2: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressTwo) || '',
        city: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.city) || '',
        state: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.state) || '',
        postalCode: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.postalCode) || '',
        country: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.country) || 'US'
      },
      phone: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone()) || '',
      businessTypes: []
    };
  });
  const onClose = value => {
    reportToAppcues('form-success', 'first_login');
    dismissModal(value);
  };
  async function onXClose() {
    logBI(18103);
    reportToHeap('preliminary-onboarding', 'click', 'user-click-quit-vendor-onboarding');
    const shouldSwitchToOtherBusiness = await overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Are you sure?",
          content: /*#__PURE__*/React.createElement(Typography, null, "Once you quit the Service Provider onboarding process, you will be redirected to your existing account."),
          primaryButtonLabel: "Quit onboarding process",
          onPrimaryButtonClick: () => {
            logBI(18104);
            reportToHeap('preliminary-onboarding', 'click', 'user-click-quit-vendor-onboarding-approve');
            reportToHubspot('create_vendor_account_canceled_v3');
            dismissModal(true);
          },
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => dismissModal(false),
          onCloseButtonClick: () => dismissModal(false),
          "data-testid": "quit-confirmation"
        });
      }
    });
    const firstValidWorkspace = workspaces && workspaces.find(isValidWorkspace);
    if (shouldSwitchToOtherBusiness && firstValidWorkspace) {
      await switchBusiness(firstValidWorkspace.id);
      dismissModal(true);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "vendor-onboarding-modal",
    className: styles.root
  }, shouldShowCloseButton && /*#__PURE__*/React.createElement(CloseButton, {
    className: styles.closeBtn,
    skin: "transparent",
    "data-testid": "close-btn",
    onClick: onXClose
  }), step === Step.First ? /*#__PURE__*/React.createElement(FirstStep, {
    initialState: vobData,
    onSubmit: formData => {
      var _formData$name, _formData$name2;
      const biLogData = {
        firstName: (_formData$name = formData.name) === null || _formData$name === void 0 ? void 0 : _formData$name.first,
        lastName: (_formData$name2 = formData.name) === null || _formData$name2 === void 0 ? void 0 : _formData$name2.last,
        companyName: formData.companyName,
        businessType: formData.businessTypes,
        numOfInvoices: formData.numOfInvoices
      };
      logBI(10325, biLogData);
      const newFormData = _objectSpread(_objectSpread({}, vobData), formData);
      setVobData(newFormData);
      setStep(Step.Second);
    }
  }) : null, step === Step.Second ? /*#__PURE__*/React.createElement(SecondStep, {
    initialState: vobData,
    onSubmit: formData => {
      logBI(10326, formData);
      const newFormData = _objectSpread(_objectSpread({}, vobData), formData);
      setVobData(newFormData);
      setStep(Step.Saving);
    }
  }) : null, step === Step.Saving ? /*#__PURE__*/React.createElement(SavingStep, {
    vobData: vobData,
    onSavingSuccess: showQboStep ? () => setStep(Step.QBO) : onClose,
    onErrorBackButton: errorType => {
      if (errorType === ErrorType.General) {
        setStep(Step.First);
      } else {
        setStep(Step.Second);
      }
    }
  }) : null, step === Step.QBO ? /*#__PURE__*/React.createElement(QBOStep, {
    onCancel: onClose,
    vobQboState: vobQboState
  }) : null, step === Step.QBOSetup ? /*#__PURE__*/React.createElement(QBOSetupStep, {
    onContinue: onClose
  }) : null);
}